import { gql } from '@apollo/client';

export default gql`
  mutation createPCategory(
    $branch: String
    $name: String
    $nameAr: String
    $disabled: Boolean
    $additionId: String
  ) {
    createPCategory(
      branch: $branch
      name: $name
      nameAr: $nameAr
      disabled: $disabled
      additionId: $additionId
    ) {
      ok
      message
      data
      error
    }
  }
`;
